<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <div class="operate">
      <div class="search">
        <b-form-select v-model="search.action" :options="options.action">
          <template #first>
            <b-form-select-option :value="null" disabled>-- 動作 --</b-form-select-option>
          </template>
        </b-form-select>

        <b-form-input
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="業務編號"
          v-model="search.number"
          @keyup.enter="getSalesLogs(1)" />

        <b-form-input
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="內容"
          v-model="search.value"
          @keyup.enter="getSalesLogs(1)" />

        <date-picker
          v-model="search.date_S"
          :position="'right'"
          placeholder="開始日期"
        ></date-picker>

        <date-picker
          v-model="search.date_E"
          :position="'right'"
          placeholder="結束日期"
        ></date-picker>
      </div>

      <div class="btn-area">
        <div class="btn-function">
          <b-button variant="danger" @click="resetSearch()">重置</b-button>

          <b-button variant="success" @click="getSalesLogs(1)">搜尋</b-button>
        </div>
      </div>
    </div>

    <tables-page
      :tableData="data.table_data"
      :tableFields="data.table_fields"
      :pageData="data.page"
      v-on:result="getSalesLogs"
    >
      <template #cell(action)="row">
        <span v-if="row.item.action === 'insert'">新增</span>
        <span v-else-if="row.item.action === 'update'">更新</span>
        <span v-else-if="row.item.action === 'delete'">刪除</span>
      </template>

      <template #cell(created_at)="row">
        {{ convertRocDate(row.item.created_at) }}
      </template>
    </tables-page>
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import TablesPage from "@/components/layouts/TablesPage";
import businessApi from "@/models/API/businessApi";
import { convertRocDate } from "@/models/HELPERS/common.js";
import datePicker from '@/components/common/DatePicker';

export default {
  name: 'businessLog',
  components: {
    BreadCrumb,
    TablesPage,
    datePicker
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '操作日誌', url: '', isActive: true },
          { name: '業務LOG', url: '', isActive: false }
        ]
      },
      options: {
        action: [
          { value: '', text: '全部' },
          { value: 'insert', text: '新增' },
          { value: 'update', text: '更新' },
          { value: 'delete', text: '刪除' },
        ],
      },
      search: {
        number: '',
        action: null,
        value: '',
        date_S: '',
        date_E: ''
      },
      data: {
        table_data: [],
        table_fields: [
          {
            key: "user",
            label: "帳號",
          },
          {
            key: "action",
            label: "動作",
          },
          {
            key: "target",
            label: "業務編號",
          },
          {
            key: "content",
            label: "變動內容",
          },
          {
            key: "created_at",
            label: "變動時間"
          },
        ],
        page: {},
      }
    }
  },
  mounted() {
    this.businessApi = new businessApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.data.page = Object.assign({}, this.businessApi.page);
      this.getSalesLogs();
    },
    convertRocDate,
    // 查詢業務LOG
    getSalesLogs(pageIndex = null) {
      const params = {
        ...this.search,
        'PageSize': this.data.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.data.page.pageIndex,
      };
      this.businessApi.getSalesLogs((response) => {
        const res = response.data;

        this.data.page.totalCount = res.total; // 總筆數
        this.data.table_data = res.data;
      }, params)
    },
    // 重置欄位，並搜尋
    resetSearch() {
      this.search = {
        number: '',
        action: '',
        value: '',
        date_S: '',
        date_E: ''
      }

      this.getSalesLogs(1);
    }
  }
}
</script>

<style lang="scss" scoped>
.operate {
  display: flex;
  white-space: nowrap;
  margin-bottom: 20px;
  column-gap: 20px;
  .search {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    flex-basis: 80%;
  }
  .btn-area {
    flex-basis: 20%;
    .btn-function {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/businessLog.vue